import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { fetch$ } from "../../fable_modules/Fable.Fetch.2.4.0/Fetch.fs.js";
import { singleton, empty } from "../../fable_modules/fable-library.3.7.12/List.js";
import { Union, Record } from "../../fable_modules/fable-library.3.7.12/Types.js";
import { list_type, string_type, union_type, record_type, bool_type, int32_type, class_type } from "../../fable_modules/fable-library.3.7.12/Reflection.js";
import { AnatomicalRegionViewModel$reflection } from "../../Optiscan.Models/View/AnatomicalRegion.js";

export function dataUrlToBlob(url) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetch$(url, empty()).then((_arg1) => (_arg1.blob())))));
}

export function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = ((evt) => {
            resolve(evt.target.result);
        });
        reader.onerror = ((_arg1) => {
            reject(new Error("Failed to read blob"));
        });
        reader.readAsDataURL(blob);
    });
}

export class SelectedSequence extends Record {
    constructor(sessionId, streamPathIndex, macro) {
        super();
        this.sessionId = sessionId;
        this.streamPathIndex = (streamPathIndex | 0);
        this.macro = macro;
    }
}

export function SelectedSequence$reflection() {
    return record_type("Client.Patients.Historical.Common.SelectedSequence", [], SelectedSequence, () => [["sessionId", class_type("System.Guid")], ["streamPathIndex", int32_type], ["macro", bool_type]]);
}

export class LoadingState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LoadingFileList", "LoadingDicoms", "Reloading", "Loaded", "Failed"];
    }
}

export function LoadingState$reflection() {
    return union_type("Client.Patients.Historical.Common.LoadingState", [], LoadingState, () => [[], [], [], [], []]);
}

export class SessionAnnotationNoteState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Creating", "Editing", "Deleting", "Nothing"];
    }
}

export function SessionAnnotationNoteState$reflection() {
    return union_type("Client.Patients.Historical.Common.SessionAnnotationNoteState", [], SessionAnnotationNoteState, () => [[], [], [], []]);
}

export class FrameFile extends Record {
    constructor(filePath, flagged) {
        super();
        this.filePath = filePath;
        this.flagged = flagged;
    }
}

export function FrameFile$reflection() {
    return record_type("Client.Patients.Historical.Common.FrameFile", [], FrameFile, () => [["filePath", string_type], ["flagged", bool_type]]);
}

export class AnatomicalRegionIntrimType extends Record {
    constructor(frameCount, streamPath) {
        super();
        this.frameCount = (frameCount | 0);
        this.streamPath = streamPath;
    }
}

export function AnatomicalRegionIntrimType$reflection() {
    return record_type("Client.Patients.Historical.Common.AnatomicalRegionIntrimType", [], AnatomicalRegionIntrimType, () => [["frameCount", int32_type], ["streamPath", string_type]]);
}

export class FlaggedImageListItem extends Record {
    constructor(sessionId, streamPathIndex, frameIndex, streamPath) {
        super();
        this.sessionId = sessionId;
        this.streamPathIndex = (streamPathIndex | 0);
        this.frameIndex = (frameIndex | 0);
        this.streamPath = streamPath;
    }
}

export function FlaggedImageListItem$reflection() {
    return record_type("Client.Patients.Historical.Common.FlaggedImageListItem", [], FlaggedImageListItem, () => [["sessionId", class_type("System.Guid")], ["streamPathIndex", int32_type], ["frameIndex", int32_type], ["streamPath", string_type]]);
}

export const defaultFrameFile = new FrameFile("Unknown", false);

export class FileMetadata extends Record {
    constructor(streamPaths, frames, flaggedImages, frameToSequenceMap, sessionId) {
        super();
        this.streamPaths = streamPaths;
        this.frames = frames;
        this.flaggedImages = flaggedImages;
        this.frameToSequenceMap = frameToSequenceMap;
        this.sessionId = sessionId;
    }
}

export function FileMetadata$reflection() {
    return record_type("Client.Patients.Historical.Common.FileMetadata", [], FileMetadata, () => [["streamPaths", list_type(string_type)], ["frames", list_type(list_type(FrameFile$reflection()))], ["flaggedImages", list_type(FlaggedImageListItem$reflection())], ["frameToSequenceMap", list_type(AnatomicalRegionViewModel$reflection())], ["sessionId", class_type("System.Guid")]]);
}

export function FileMetadata_get_empty() {
    return new FileMetadata(empty(), singleton(singleton(defaultFrameFile)), empty(), empty(), "00000000-0000-0000-0000-000000000000");
}

